var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRestartAltPink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "restart_alt_pink_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#restart_alt_pink_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5148E",
  d: "M6.551 13.8a5.233 5.233 0 0 1-2.8-1.892c-.722-.94-1.083-2.02-1.083-3.242 0-.633.106-1.236.317-1.808a5.489 5.489 0 0 1 .9-1.575.615.615 0 0 1 .45-.209.64.64 0 0 1 .483.209.642.642 0 0 1 .192.45.755.755 0 0 1-.175.5 4.012 4.012 0 0 0-.617 1.133 3.893 3.893 0 0 0-.217 1.3c0 .9.264 1.703.792 2.408a3.93 3.93 0 0 0 2.042 1.442.706.706 0 0 1 .358.25.64.64 0 0 1 .142.4.643.643 0 0 1-.234.525.585.585 0 0 1-.55.108Zm2.9 0a.573.573 0 0 1-.55-.117.667.667 0 0 1-.091-.917.706.706 0 0 1 .358-.25 4.041 4.041 0 0 0 2.042-1.45c.527-.7.791-1.5.791-2.4 0-1.111-.389-2.056-1.166-2.833C10.057 5.055 9.112 4.666 8 4.666h-.05l.267.267a.632.632 0 0 1 .183.466.632.632 0 0 1-.183.467.632.632 0 0 1-.467.183.632.632 0 0 1-.466-.183l-1.4-1.4a.585.585 0 0 1-.142-.217.738.738 0 0 1-.042-.25c0-.089.014-.172.042-.25a.585.585 0 0 1 .142-.216l1.4-1.4a.632.632 0 0 1 .466-.184c.19 0 .345.061.467.184a.632.632 0 0 1 .183.466.632.632 0 0 1-.183.467l-.267.267h.05c1.49 0 2.75.516 3.784 1.55 1.033 1.033 1.55 2.294 1.55 3.783 0 1.211-.362 2.289-1.084 3.233a5.216 5.216 0 0 1-2.8 1.9Z"
}))));
export default SvgRestartAltPink;